import React, { useContext, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import { Content } from '../../lib/FL';
import ContentListDetailSwitch from '../atom/ContentListDetailSwitch';
import DeviceSwitch from '../atom/DeviceSwitch';
import ContentPreview from '../contents/ContentPreview';
import PreviewFrame from '../atom/PreviewFrame';

import styles from './PreviewModal.module.scss';

type Props = {
  content: Content;
};

const ContentPreviewModal: React.FC<Props> = ({ content }) => {
  const setModal = useContext(ModalDispatchContext);
  const closeModal = () => setModal(null);

  const [isDetailPagePreview, setIsDetailPagePreview] = useState<boolean>(false);
  const [device, setDevice] = useState<string>('pc');

  /**
   * コンテンツが「物件一覧・詳細」かどうか
   */
  const isBukkenListDetailContent = content.en_name === 'list';

  /**
   * コンテンツが「地図検索オプション」かどうか
   */
  const isMapContent = content.en_name === 'map';

  /**
   * コンテンツが「カスタム物件一覧・詳細」か「建物アーカイブ」かどうか
   */
  const isBukkenListDetailStaticContent = content.en_name === 'search' || content.en_name === 'archive';

  /**
   * 「一覧｜詳細」の切り替えリンクを出すかどうか
   */
  const showsListDetailSwitch = content.icons.includes('cms_detail') || isBukkenListDetailContent || isBukkenListDetailStaticContent;

  return (
    <div className={styles.wrapper} onClick={(e) => e.stopPropagation()} role='button'>
      <header className={styles.header}>
        <div className={styles.header__left}>
          <h2 className={styles.title}>
            <span className={styles.title__main}>{content.ja_name}</span>
            <a
              href={`${window.location.origin}/content/${content.en_name}${isDetailPagePreview ? '/detail' : ''}`}
              target='_blank'
              rel='noreferrer'
            >
              <button type='button'>
                <FontAwesomeIcon icon={faExternalLink} className={styles.title__link} />
              </button>
            </a>
          </h2>
          {showsListDetailSwitch && (
            <ContentListDetailSwitch
              isDetailPagePreview={isDetailPagePreview}
              setIsDetailPagePreview={(arg: boolean) => setIsDetailPagePreview(arg)}
            />
          )}
        </div>
        <div className={styles.header__center}>
          <DeviceSwitch activeDevice={device} setActiveDevice={(d: string) => setDevice(d)} />
        </div>
        <div className={styles.header__right}>
          {(isBukkenListDetailContent || isMapContent) && (
            <a href='https://list.cbiz.co.jp/' target='_blank' rel='noreferrer' className={styles.listDemo}>
              デモ画面の体験はこちら
            </a>
          )}
          <button className={styles.close} type='button' onClick={closeModal}>
            <FontAwesomeIcon icon={faTimes} className={styles.close__icon} />
          </button>
        </div>
      </header>
      <div className={styles.preview}>
        <PreviewFrame device={device}>
          <ContentPreview contentEnName={content.en_name} device={device} isDetail={isDetailPagePreview} />
        </PreviewFrame>
      </div>
    </div>
  );
};

export default ContentPreviewModal;
